import { useDefaultAssignmentPromptConfigs } from "@/components/assignments/assignmentPromptConfigs";
import { Text } from "@/components/ui/Text";
import { useStore } from "@/store";
import { useIsLoggedIn } from "@/store/selectors";
import { useStyles } from "@/styles/useStyles";
import { Space, Stack } from "@mantine/core";
import { IconArrowRight, IconExternalLink } from "@tabler/icons-react";
import { Button } from "@/components/ui/Button";
import { Navigation } from "@/services/Navigation";
import { AssignmentService } from "@/services/AssignmentService";
import { config } from "@/config";
import { Link } from "@/components/ui/Link";
import { Analytics } from "@/services/Analytics";

export function AssignmentDefaultContent() {
  const { theme } = useStyles();
  const isLoggedIn = useIsLoggedIn();

  const setActiveAssignmentId = useStore(
    (state) => state.partnerApp.setActiveAssignmentId,
  );

  const defaultAssignmentPromptConfigs = useDefaultAssignmentPromptConfigs();
  return (
    <Stack
      align="center"
      justify="flex-start"
      px={0}
      gap="lg"
      w="100%"
      bg="primary.0"
      h="100%"
    >
      {/* <Group justify="flex-end" w="100%" px="sm" py="sm">
        <ActionIcon
          variant="light"
          size="md"
          radius="xl"
          color="text.6"
          style={{ zIndex: 100 }}
          onClick={() => setIsAssignmentManagerOpen(false)}
        >
          <IconX size={20} />
        </ActionIcon>
      </Group> */}
      <Space h="10vh" />
      <Stack align="center" justify="center" px="xl" gap="lg" w="100%">
        {/* <ResourceConfigs.assignment.Icon
          size={80}
          color={theme.colors.primary[7]}
        /> */}
        <Text titleStyle="h2" lh={1.2} ta="center" mx="auto" maw={550}>
          Share a career exploration assignment with your students in just a few
          minutes
        </Text>

        <Button
          variant="filled"
          radius="xl"
          size="lg"
          px={50}
          color="primary"
          rightSection={<IconArrowRight />}
          // leftSection={<IconPlus />}
          className="pulseBorder"
          onClick={async () => {
            Analytics.click({
              action: "create-assignment",
              label: "Create an assignment",
            });

            if (!isLoggedIn) {
              Navigation.navToLogin();
              return;
            }
            const assignmentId =
              await AssignmentService.createNewBlankAssignment({
                defaultAssignmentPromptConfigs,
              });

            setActiveAssignmentId(assignmentId);
          }}
        >
          Get started
        </Button>

        <Space h="xs" />

        <iframe
          src="https://player.vimeo.com/video/1109197865?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
          width="100%"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          title="Advize Assignment Product Walkthrough"
          style={{
            aspectRatio: "16/9",
            width: "100%",
            height: "auto",
            border: `1px solid ${theme.colors.border[2]}`,
            borderRadius: theme.radius.md,
            boxShadow: theme.shadows.lg,
            maxWidth: 600,
          }}
        ></iframe>
        <Space h="xs" />
        <Stack gap="xs">
          {[
            `▶️ 10,000+ videos to spark curiosity`,
            `📊 Detailed engagement and reflection data`,
            `🤝 Drive 1-on-1 session scheduling`,
            `📥 Export to Canvas or CSV`,
            `🔗 No IT needed - just a shareable link`,
          ].map((step) => (
            <Stack key={step} align="center" justify="center" gap="xs">
              <Text size="md" titleStyle="h5" ta="center" c="text.7">
                {step}
              </Text>
            </Stack>
          ))}
        </Stack>
        {/* <Space h="xs" /> */}
        <Link
          to={config.assignmentGuideUrl}
          style={{
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            opacity: 0.75,
          }}
          target="_blank"
        >
          Assignment Guide + FAQ{" "}
          <IconExternalLink size={16} style={{ marginLeft: 4 }} />
        </Link>
        <Space h="xs" />
        {/* <Text size="sm" ta="center">
            <Link
              to="/partner/assignments"
              style={{ display: "flex", alignItems: "center", gap: 4 }}
            >
              Click here to check out an example assignment
            </Link>
          </Text> */}
      </Stack>
    </Stack>
  );
}
